import { BankerRepoImpl } from "domain/repository/Banker/BankerRepoImpl";
import { CollectionRepoImpl } from "domain/repository/Collection/CollectionRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { useCollectionTracked } from "presentation/store/Collection/CollectionProvider";
import { CollectionVM } from "presentation/viewModel/Collection/CollectionVM";
import { useMemo } from "react";

export const useCollectionVM = () => {
    const [, setCollectionState] = useCollectionTracked();
    const collectionVM = useMemo(() =>
        CollectionVM({
            dispatch: [setCollectionState],
            repo: CollectionRepoImpl(),
            bankerRepo: BankerRepoImpl(),
            companyRepo: CompanyRepoImpl(),
        }), [setCollectionState])

    return collectionVM
}